<template>
 <div class="box">
    <div class="orioc-container">
          <div class="title">
            <p class="title-content">产品和服务</p>
            <div class="title-nav" ></div>
          </div>
       <div class="card-container">
         <div class="card-box" v-for="item in card_data" :key="item.title" >
            <!-- 救援牌跟互动屏的点击事件先隐藏 -->
          <div v-if="item.title == '应急救援平台' || item.title == '互动屏' || item.title == '物联网平台'">
            <div class="card article-card ">
              <div class="card-body">
                    <img class="card-logo" :src="item.logo_url" >
                    <h6 class="title">{{item.title}}</h6>
                    <p class="card-content">
                      &nbsp;&nbsp;{{item.content}}
                    </p>
              </div>
            </div>
          </div>

           <a v-else>
            <div class="card article-card ">
              <div class="card-body">
                    <img class="card-logo" :src="item.logo_url" >
                    <h6 class="title">{{item.title}}</h6>
                    <p class="card-content">
                      &nbsp;&nbsp;{{item.content}}
                    </p>
                    <!-- <span v-if="item.title === '物联网平台'" class="card-entry" style="color: #BFBFBF">正在开发中</span> -->
                    <!--统一数据平台不可点击-临时更改-->
                    <span v-if="item.title === '统一数据平台'" class="card-entry"></span>
              </div>
            </div>
            </a>
         </div>
       </div>
    </div>
 </div>
</template>

<script>
  export default {
    name: "index",
    data(){
      return{
        card_data:Object.freeze([
          {
            logo_url:require('../../../static/svg/监管.svg'),
            url:'',
            title:'政府监管平台',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，对辖区范围内电梯的日常维保情况和电梯健康状态、对维保单位、物业单位、技师的基础信息维护、对电梯应急救援情况等进行可视化管理'
          },
          {
            logo_url:require('../../../static/svg/应急救援.svg'),
            url:'',
            title:'应急救援平台',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，提供多渠道接入应急救援指挥中心，可实现处理电梯险情的接警、调度、跟踪、归档和统计分析。为电梯和乘客安全提供有力的保障'
          },
          {
            logo_url:require('../../../static/svg/维保.svg'),
            url:'',
            title:'维保单位平台',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，致力于维保业务工作的信息化和智能化。从维保项目、合同、电梯、工单、纸质保单/电子保单、维保档案、技师等全链条实现信息化管理'
          },
          {
            logo_url:require('../../../static/svg/物业.svg'),
            url:'',
            title:'物业单位平台',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，能够监控维保企业的电梯维保计划、过程和结果，能够调度电梯的维保档案。同时基于物联网技术，实时预测电梯的健康状态，协同维保企业保障电梯安全'
          },

          {
            logo_url:require('../../../static/svg/物联网.svg'),
            title:'物联网平台',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，符合国标GB-7588及监规TSG T7001条件下，能采集电梯基本安全开关信号(如:安全回路、门锁、抱闸、检修、运行、门区等)监控电梯实时运行状态并故障推送'
          },
          {
            logo_url:require('../../../static/svg/互动屏.svg'),
            url:'',
            title:'互动屏',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，实现电梯日常保养和维修的公示、为乘客评价和投诉提供便捷的通道。同时提供公益和商业广告服务，实现电梯场景的安全和价值最大化'
          },
          {
            logo_url:require('../../../static/svg/统一数据.svg'),
            // 暂时屏蔽统一数据使其不可点击
            // url:'',
            title:'统一数据平台',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，创建设备(如电梯)、人员(如技师、安全员)、机构(如维保单位、维保单位、监察机构、检验检测机构)等统一规范的标准数据体系，为电梯大数据分析提供基础'
          },
          {
            logo_url:require('../../../static/svg/运营中心平台.svg'),
            //url:'',
            title:'运营中心平台',
            content:'接入电梯大叔*互联网+的智慧电梯服务云平台，对不同平台下企业和人员的账号、资质、对用户的统一管控，对电梯的注册、备案，对合同的登记备案，对多渠道的统一内容发布等进行综合管理'
          },
        ])
      }
    },
    methods:{

    }
  }
</script>
<style lang="scss" scoped>
  .box{
    padding-top: 30px;
    padding-bottom: 10px;
    background: #FBFDFF;
  }
  .title{
    text-align: center;
    margin-bottom: 20px;
  }
  .title-content{
    font-size: 20px;
    font-weight: 500;
    padding: 10px 5px 0;
  }
  .title-nav{
    width: 30px;
    height: 3px;
    background: #1B91FF;
    border-radius: 150px;
    margin: 20px auto;
  }
  .card-container{
    .card-box{
      float: left;
      width: 25%;
      .card-body{
        padding:55px 30px 30px ;
        text-align: center;
      }
      .card{
        position: relative;
        transition: all .2s ease;
        .title{
          text-align: center;
        }
        .card-logo{
          width: 40px;
          height: 40px;
          background-size: cover;
          margin-bottom:20px ;
        }
        .card-content{
          text-align: center;
          font-size: 12px;
          color: #84868A;
          line-height: 22px;
          margin: 10px;
        }
        .card-entry{
          font-size: 13px;
          width: 100%;
          text-align: center;
          display: block;
        }

      }
      .article-card{
        margin-bottom: 30px;
      }

    }
  }
  .card-container:after {
    clear: both;
  }
  .card-container:before, .card-container:after {
    content: " ";
    display: table;
  }
  .card-box:hover .article-card {
    cursor: pointer;
    background: #fff;
    transform: scale(1.1);
    transition: all .2s linear;
    color: #1B91FF;
    box-shadow: 0 15px 35px rgba(50,50,93,.1),0 5px 15px rgba(0,0,0,.07)!important;
    border-radius: 4px;
  }
  .shadow{
    box-shadow: 0 15px 35px rgba(50,50,93,.1),0 5px 15px rgba(0,0,0,.07)!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Product/index.vue